import { render } from "./IconChevronRightSmall.vue?vue&type=template&id=502e0272"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronRightSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "502e0272"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('502e0272', __exports__)) {
    api.reload('502e0272', __exports__)
  }
  
  module.hot.accept("./IconChevronRightSmall.vue?vue&type=template&id=502e0272", () => {
    api.rerender('502e0272', render)
  })

}


export default __exports__